import { SensorData } from 'Simulations/SensorPoint';
import { FilterStage, StageParameters } from '../../Stage';
import { StageContext } from '../../Context';

export interface AloneStageParameters extends StageParameters {}

class AloneStage extends FilterStage<AloneStageParameters> {
    // Store sensor IDs once per stage execution. (Avoid O(n^2) lookups in `filter()`):
    private sensorIds: Set<number> = new Set();

    constructor() {
        super({});
    }

    protected override processAll(context: StageContext): StageContext {
        // Store sensorIDs once (to avoid mapping all sensors for every sensor, which would be O(n^2)):
        this.sensorIds = new Set(context.sensors.map((sensor) => sensor.getID()));
        const outputSensors = context.sensors.map((sensorData) => this.process(sensorData, context)).filter((sd) => sd !== null);
        this.sensorIds.clear();

        return { ...context, sensors: outputSensors };
    }

    protected filter(sensorData: SensorData, _context: StageContext): boolean {
        // Keep sensors with atleast one orthogonally adjacent neighbor:
        const neighbours = sensorData.getSensorPoint().neighbors6;
        return neighbours.some((neighbour) => this.sensorIds.has(neighbour.getID()));
    }
}

export default AloneStage;
